<template>
  <div class="wrapper">
    <intro v-if="selected.id === 0" :onStart="start"/>
    <div class="map-wrapper">
      <gmap-map
        v-if="selected.id > 0"
        ref="map"
        class="map"
        :center="selected.position"
        :zoom="mapZoom"
        :options="mapOptions">
        <gmap-marker
          :key="index"
          v-for="(m, index) in locations"
          :position="m.position"
          :clickable="true"
          :icon="(m.info && icons.numbers[index]) ? icons.numbers[index] : defaultIcon"
          @click="markerOnClick(m)" />
      </gmap-map>
      <button v-if="streetviewEnabled" style="display:none" class="streetview-toggle" @click="closeStreetView()">Back to the map</button>
      <gmap-map
        v-if="streetviewEnabled"
        ref="miniMap"
        class="mini-map"
        :center="selected.position"
        :zoom="mapZoom"
        :options="mapOptions">
        <gmap-marker
          :key="index"
          v-for="(m, index) in locations"
          :position="m.position"
          :clickable="true"
          :icon="(m.info && icons.numbers[index]) ? icons.numbers[index] : defaultIcon"
          @click="markerOnClick(m)" />
      </gmap-map>
    </div>
    <div class="info" v-if="selected.id > 0">
      <info :selected="selected" :toggleGallery="toggleGallery" :toggleMarker="toggleMarkerByIndex" :locationsQty="locations.length"/>
    </div>
    <h3 v-if="showGallery" class="expanded-title">{{selected.info.title}}</h3>
    <div  v-if="showGallery" class="carousel">
      <carousel
        ref="gallery"
        :navigationEnabled="true"
        :paginationEnabled="false"
        :perPage="1">
        <slide
          :key="index"
          v-for="(img, index) in gallery">
          <div class="slider-image-wrapper">
            <img class="slider-image" @click="toggleGallery" :src="img" />
          </div>
        </slide>
      </carousel>
      <div class="image-note">(click on the image to close)</div>
    </div>
  </div>
</template>

<script>
  import * as VueGoogleMaps from 'vue2-google-maps'
  import Vue from 'vue'
  import { Carousel, Slide } from 'vue-carousel'
  import Intro from './Intro'
  import Info from './Info'
  import mapStyles from '../assets/map-styles'
  import data from '../assets/data'
  import icons from '../assets/icons'
  import 'whatwg-fetch'

  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyAMfwTu0H2dqHd7nEwIRcOe38DQd1LF40M',
      libraries: 'places'
    },
    installComponents: true
  })

  export default {
    components: {
      Intro,
      Info,
      Carousel,
      Slide
    },
    created () {
      fetch('https://s3-ap-southeast-2.amazonaws.com/kuradev-kurator-uploads/london-terror.json')
        .then((response) => {
          return response.json()
        }).then((json) => {
          this.selected = json.selected
          this.locations = json.locations
          console.log('parsed json', json)
        }).catch((ex) => {
          console.log('parsing failed', ex)
        })
    },
    data () {
      return {
        ...data,
        mapOptions: { styles: mapStyles, streetViewControl: false },
        icons,
        defaultIcon: 'https://maps.google.com/mapfiles/kml/shapes/library_maps.png',
        streetviewEnabled: false,
        mapZoom: window.innerWidth > 700 ? 15 : 14,
        showGallery: false
      }
    },
    methods: {
      toggleMarkerByIndex (direction) {
        let markerIdx
        switch (direction) {
          case 'next': markerIdx = this.selected.id; break
          case 'prev': markerIdx = this.selected.id - 2; break
          case 'home': return this.closeStreetView()
        }
        const marker = this.locations[markerIdx]
        this.markerOnClick(marker)
      },
      markerOnClick (m) {
        this.selected = m
        this.gallery = m.info.gallery
        const panorama = this.$refs.map.$mapObject.getStreetView()
        panorama.setOptions({ addressControl: false })
        panorama.setPosition(m.position)
        panorama.setPov({
          heading: m.pov.heading,
          pitch: m.pov.pitch
        })
        panorama.setZoom(m.zoom)
        this.streetviewEnabled = true
        panorama.setVisible(true)
        setTimeout(() => {
          window.scrollTo(0, 0)
          window.twttr.widgets.load()
          window.instgrm.Embeds.process()
        }, 100)
      },
      closeStreetView () {
        this.streetviewEnabled = false
        const panorama = this.$refs.map.$mapObject.getStreetView()
        panorama.setVisible(false)
        this.selected = data.selected
      },
      toggleGallery () {
        this.showGallery = !this.showGallery
      },
      start () {
        this.selected = this.locations[0]
        setTimeout(() =>
          this.markerOnClick(this.selected),
          100)
      }
    }
  }
</script>

<style scoped>
  .wrapper {
    display: flex;
    flex-direction: row;
    height: 100vh;
    max-height: 100vh;
    width: 100%;
    box-sizing: border-box;
  }
  @media (max-width: 450px) {
    .wrapper {
      flex-direction: column;
    }
    .map-wrapper {
      min-height: 300px;
      height: 300px;
      max-height: 300px;
    }
    .mini-map {
      display: none;
    }
  }
  @media (min-width: 451px) and (max-width: 990px) {
    .info {
      width: 50vw;
    }
    .map-wrapper {
      width: 50vw;
    }
  }
  .info {
    flex: 5;
    box-sizing: border-box;
  }
  .map-wrapper {
    flex: 7;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
  }
  .pano {
    flex: 3;
    box-sizing: border-box;
  }
  .map {
    flex: 2;
    box-sizing: border-box;
  }
  .mini-map {
    height: 30vh;
  }
  .streetview-toggle {
    position: absolute;
    z-index: 10;
    width: 200px;
    margin-left: calc(50% - 100px);
    margin-right: calc(50% - 100px);
    background: #FFF;
    padding: 12px 8px;
    top: 12px;
    border:0;
  }
  .carousel {
    position: fixed;
    width:100vw;
    height: 100vh;
    top:0px;
    left: 0px;
    z-index: 10;
    padding-top: 20px;
    background:rgba(255,255,255,0.95)
  }
  .VueCarousel-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slider-image-wrapper {
    width: 90vw;
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slider-image {
    max-width:100%;
    height: auto;
  }
.expanded-title {
  margin:0px;
  padding:0px;
  background: linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0));
  position: fixed;
  width:100%;
  color:#FFF;
  text-align:center;
  top:0px;
  left:0px;
  z-index:11;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// Map.vue?97727ee4